module.exports = __webpack_public_path__ + "assets/img/hh_contact.17ea31f0.jpg";